import selectors from '../../../../redux/selectors/Index.js';
import Constants from '../../../../model/AppConfiguration.js';

export default {
  selectPassenger,
  onRouteIdChange,
  getSelectionsForPassenger,
  getNameByType,
  getValueByType,
  getSubselectionByType,
  onMealSelection,
  onMealSubselection,
  updateMeals,
};

function selectPassenger (id) {
  let { flights, passengers, routeId } = this.state;
  let selectedPassenger;
  let passengerExist = false;
  passengers.find(passenger => {
    if (passenger.id === id) {
      passenger.selected = !passenger.selected;
      selectedPassenger = passenger;
    }
  });
  flights.find(flight => {
    if (flight.routeId === routeId) {
      flight.passengers.find(passenger => {
        if (passenger.id === id) {
          passenger.selected = !passenger.selected;
          passengerExist = true;
        }
      });

      if (!passengerExist && selectedPassenger) {
        let newFlightPassenger = {
          id: selectedPassenger.id,
          selected: selectedPassenger.selected,
        };
        flight.passengers.push(newFlightPassenger);
      }
    }
  });

  this.setState({ passengers, flights });
}

function onRouteIdChange (props) {
  let { flights, routeId, isFetching, activePassenger } = props;
  let stateFlights = this.state.flights;
  let flightsLoaded = flights && flights.length;
  let newState = {};
  let meals = [];
  let selectedMeals = [];
  if (!isFetching && flightsLoaded) {
    if (stateFlights && stateFlights.length) {
      meals = selectors.meals.getMeals(stateFlights, routeId);
      selectedMeals = selectors.meals.getSelectedMeals(stateFlights, routeId);
      newState = getSelectionsForPassenger(meals, selectedMeals, activePassenger);
    }
    this.setState({
      flights,
      meals,
      selectedMeals,
      routeId,
      appetizer: newState ? newState.appetizer : '',
      mainMeal: newState ? newState.mainMeal : '',
      dessert: newState ? newState.dessert : '',
      appetizerSubselection: newState ? newState.appetizerSubselection : '',
      mainMealSubselection: newState ? newState.mainMealSubselection : '',
      dessertSubselection: newState ? newState.dessertSubselection : '',
      notes: newState ? newState.notes : '',
    });
  } else {
    this.setState({ routeId });
  }
}

function getSelectionsForPassenger (meals, selectedMeals, activePassenger) {
  let selectedMealForPassenger = selectedMeals.find(passenger => passenger.id === activePassenger);
  if (!selectedMealForPassenger) return;
  let meal = {
    appetizer: '',
    mainMeal: '',
    dessert: '',
    appetizerSubselection: '',
    mainMealSubselection: '',
    dessertSubselection: '',
    notes: selectedMealForPassenger.notes || '',
  };
  selectedMealForPassenger.meals.map(selectedMeal => {
    let propertyName = getNameByType(selectedMeal.type);
    if (selectedMeal.description) {
      meal[ `${propertyName}Subselection` ] = selectedMeal.description;
    }
    meal[ propertyName ] = selectedMeal.id;
  });
  return meal;
}

function getNameByType (label) {
  if (!label) return '';
  let lowercasedLabel = label.toLowerCase();
  switch (lowercasedLabel) {
    case Constants.MEAL.APPETIZER:
      return 'appetizer';
    case Constants.MEAL.MAIN:
      return 'mainMeal';
    case Constants.MEAL.DESSERT:
      return 'dessert';
    default:
      return 'mainMeal';
  }
}

function getValueByType (label) {
  if (!label) return '';
  let lowercasedLabel = label.toLowerCase();
  const { appetizer, mainMeal, dessert } = this.state;
  switch (lowercasedLabel) {
    case Constants.MEAL.APPETIZER:
      return appetizer;
    case Constants.MEAL.MAIN:
      return mainMeal;
    case Constants.MEAL.DESSERT:
      return dessert;
    default:
      return mainMeal;
  }
}

function getTypeByStateName (name) {
  if (!name) return '';

  switch (name) {
    case 'appetizer':
      return Constants.MEAL.APPETIZER;
    case 'mainMeal':
      return Constants.MEAL.MAIN;
    case 'dessert':
      return Constants.MEAL.DESSERT;
    default:
      return Constants.MEAL.MAIN;
  }
}

function getSubselectionByType (label) {
  if (!label) return '';
  let lowercasedLabel = label.toLowerCase();
  const { appetizerSubselection, mainMealSubselection, dessertSubselection } = this.state;
  switch (lowercasedLabel) {
    case Constants.MEAL.APPETIZER:
      return appetizerSubselection;
    case Constants.MEAL.MAIN:
      return mainMealSubselection;
    case Constants.MEAL.DESSERT:
      return dessertSubselection;
    default:
      return mainMealSubselection;
  }
}

function onMealSelection (e, value) {
  if (value === this.state[ e.target.name ]) return;

  let child = `${e.target.name}Subselection`;
  this.setState({ [ e.target.name ]: value, [ child ]: '' });
}

function onMealSubselection (e, parentValue) {
  let parentCheckboxIndex = e.target.name.indexOf('Subselection');
  let parent = e.target.name.slice(0, parentCheckboxIndex);
  this.setState({ [ e.target.name ]: e.target.value, [ parent ]: parentValue });
}

function updateMeals () {
  let {
    flights,
    notes,
    appetizerSubselection,
    mainMealSubselection,
    dessertSubselection,
    appetizer,
    mainMeal,
    dessert,
  } = this.state;
  let meals = {
    appetizerSubselection,
    mainMealSubselection,
    dessertSubselection,
    appetizer,
    mainMeal,
    dessert,
  };
  let { activePassenger, routeId } = this.props;
  flights.find(flight => {
    if (flight.routeId === routeId) {
      flight.selectedMeals.find(passenger => {
        if (passenger.id === activePassenger) {
          passenger.meals = convertToFlightsSelectedMeals(meals);
          passenger.notes = notes || '';
        }
      });
    }
  });

  this.props.actions.updateFlights(flights);
}

function convertToFlightsSelectedMeals (meals) {
  let convertedMeals = [];
  for (const property in meals) {
    let meal = meals[ property ];
    if (meal) {
      let description = meals[ `${property}Subselection` ] || '';
      let convertedMeal = {
        id: meal,
        type: getTypeByStateName(property),
        description,
      };
      convertedMeals.push(convertedMeal);
    }
  }
  return convertedMeals;
}



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsSelection/MealsSelectionController.js